import type { PollResult } from './poll-results.js';
const PREFIX = 'vorbello_poll_archive_v1:';
export function pollArchiveKey(organization: string): string {
  if (!/^(?:license-[1-9][0-9]{0,18}|platform-1)$/.test(organization)) throw new Error('Invalid organization');
  return PREFIX + organization;
}
export function readPollArchive(storage: Pick<Storage,'getItem'>, organization: string): PollResult[] {
  try { const value: unknown = JSON.parse(storage.getItem(pollArchiveKey(organization)) || '[]'); return Array.isArray(value) ? value.filter(x => x && typeof x.id === 'string' && typeof x.question === 'string' && Array.isArray(x.options) && Array.isArray(x.votes) && x.options.every((v: unknown) => typeof v === 'string') && x.votes.every((v: unknown) => Number.isSafeInteger(v) && (v as number) >= 0) && x.options.length === x.votes.length && typeof x.closedAt === 'string') : []; } catch (_) { return []; }
}
export function savePollArchive(storage: Pick<Storage,'getItem'|'setItem'>, organization: string, result: PollResult): void {
  const rows = readPollArchive(storage, organization).filter(x => x.id !== result.id);
  rows.unshift(result);
  storage.setItem(pollArchiveKey(organization), JSON.stringify(rows.slice(0,200)));
}
